import React from 'react';
import Nnavbar from '../components/JSX/Nnavbar';
import Slider9 from '../components/JSX/Slider9';
import Intro from '../components/JSX/Intro';
import Footernews from '../components/JSX/Footernews';

const Insights = () => (
  <>
    <Nnavbar />
    <Slider9 />
    <Intro />
    <Footernews />
  </>
);

export default Insights